import { createEdgeSpark } from "@edgespark/client";

// Youbase backend worker (staging URL is auto-promoted to production on publish)
export const WORKER_URL = "https://staging--0hxesl5d6bxgurquokll.youbase.cloud";

export const client = createEdgeSpark({ baseUrl: WORKER_URL });

export interface BlogReply {
  id: number;
  postId: number;
  authorName: string;
  message: string;
  createdAt: number;
}

export interface BlogPost {
  id: number;
  name: string;
  message: string;
  createdAt: number;
  replies: BlogReply[];
}
